module.exports = __webpack_public_path__ + "img/用户统计.764ec9f3.svg";